export const createPostalCodeSlice = (set, get) => ({
  currentPostalCode: null,
  setCurrentPostalCode: (postalCode) => set({ currentPostalCode: postalCode }),
});
